import { createAsyncThunk } from "@reduxjs/toolkit";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

/** Fetches single features */
export const fetchSingleFeatures = createAsyncThunk<{
  allSingleFeatures: FaroCoreApiTypes.AdmFeature[];
}>("planCreation/fetchSingleFeatures", async () => {
  try {
    const allSingleFeatures = await faroCoreApiClient.admin.getAllFeatures();

    return {
      allSingleFeatures,
    };
  } catch {
    throw new Error("Could not load Features");
  }
});

/** Fetches non single features meaning bundles, subscriptions and addons */
export const fetchNonSingleFeatures = createAsyncThunk<{
  allNonSingleFeatures: FaroCoreApiTypes.AdmBundle[];
}>("planCreation/fetchNonSingleFeatures", async () => {
  try {
    const allNonSingleFeatures = await faroCoreApiClient.admin.getAllBundles();

    return {
      allNonSingleFeatures,
    };
  } catch {
    throw new Error("Could not load bundles");
  }
});
